/**
 * Imported FIRST by `main.tsx`, for its side effect alone.
 *
 * ES modules evaluate their imports before their own body, so a call to
 * `installErrorReporting()` written in `main.tsx` would run only after every
 * module the app imports had already been evaluated — too late to see an
 * error thrown while one of them initialises. As the first import, this
 * module (and what it needs: the `ApiClient`, the platform check) evaluates
 * before any other module of the app.
 */
import { installErrorReporting } from "./install";

installErrorReporting();
